import { Phone, MessageCircle } from "lucide-react";
import Logo from "./Logo";
import { BUSINESS } from "@/lib/siteData";

const Header = () => (
    <header className="fixed top-0 inset-x-0 z-50 bg-[#0B132B]/80 backdrop-blur-md border-b border-amber-500/20">
        <div className="max-w-7xl mx-auto px-4 sm:px-8 lg:px-16 h-16 flex items-center justify-between">
            <a
                href="#top"
                className="flex items-center gap-3"
                data-testid="nav-logo-link"
                aria-label="Shubham Housing — back to top"
            >
                <Logo size={34} />
                <div className="leading-tight">
                    <span className="font-display font-bold text-lg tracking-wide text-slate-50 block">
                        SHUBHAM <span className="text-amber-400">HOUSING</span>
                    </span>
                    <span className="hidden sm:block text-[10px] font-mono2 uppercase tracking-[0.25em] text-amber-400/80">
                        {BUSINESS.tagline}
                    </span>
                </div>
            </a>
            <div className="flex items-center gap-2">
                <a
                    href={BUSINESS.tel1}
                    data-testid="nav-call-now-button"
                    aria-label={`Call ${BUSINESS.director} now`}
                    className="inline-flex items-center gap-2 rounded-full bg-amber-400 text-[#0B132B] px-4 py-2 text-sm font-semibold hover:bg-amber-300 transition-colors"
                >
                    <Phone size={15} /> Call Now
                </a>
                <a
                    href={BUSINESS.whatsapp}
                    target="_blank"
                    rel="noopener noreferrer"
                    data-testid="nav-whatsapp-button"
                    aria-label="Chat on WhatsApp"
                    className="hidden sm:inline-flex items-center gap-2 rounded-full border border-emerald-400/50 text-emerald-300 px-4 py-2 text-sm font-semibold hover:bg-emerald-400/10 transition-colors"
                >
                    <MessageCircle size={15} /> WhatsApp
                </a>
            </div>
        </div>
    </header>
);

export default Header;
